module.exports = __webpack_public_path__ + "media/images/trash_can_icon_blue-4b8df3adbd74ff79a4eb0512377d9257.svg";